import React from 'react';
import { Brain } from '~components/Icons';
import styles from './PulsingBrain.module.scss';

interface PulsingBrainProps {
  className?: string;
  size?: number;
}

export const PulsingBrain: React.FC<PulsingBrainProps> = ({ className = '', size = 24 }) => {
  return (
    <div className={`${styles.container} ${className}`} style={{ width: size, height: size }}>
      <div className={styles.pulseWave} />
      <Brain className={styles.brain} width={size * 0.8} height={size * 0.8} />
    </div>
  );
};

export default PulsingBrain;
